export default "__VITE_ASSET__DeFWgxRw__"